<!-- preloader -->
<!--<div class="preloader">
    <div class="loader">
      <span style="--i:1;"></span>
      <span style="--i:2;"></span>
      <span style="--i:3;"></span>
      <span style="--i:4;"></span>
      <span style="--i:5;"></span>
      <span style="--i:6;"></span>
      <span style="--i:7;"></span>
      <span style="--i:8;"></span>
      <span style="--i:9;"></span>
      <span style="--i:10;"></span>
      <span style="--i:11;"></span>
      <span style="--i:12;"></span>
      <span style="--i:13;"></span>
      <span style="--i:14;"></span>
      <span style="--i:15;"></span>
      <span style="--i:16;"></span>
      <span style="--i:17;"></span>
      <span style="--i:18;"></span>
      <span style="--i:19;"></span>
      <span style="--i:20;"></span>
      <div class="loader-plane"></div>
    </div>
  </div>-->
<!-- preloader end -->

<main class="main">

  <!-- hero area -->
  <div class="hero-section" [ngClass]="{ 'full-hero-layout': channel !== 'B2C' }">
    <div class="hero-single" [style.background-image]="'url(' + imgUrl + 'img/hero/hero-b2b.jpg)'">
      <div class="container">
        <div class="row align-items-center">
          <div class="col-lg-12 mx-auto" [class.isResHero]="!isMobile">
            <div class="hero-content text-center">
              <div class="hero-content-wrapper">
                <h1 class="hero-title">{{'Explore The World Together' | lang}}</h1>
                <p>{{'Find awesome flight deals with us' | lang}}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- hero area end -->
  <div class="search-area">
    <div class="container">
      <!-- search area -->
      <div class="search-area">
        <div class="container">
          <div class="search-wrapper" [class.isResSearch]="!isMobile">
            <!-- search header -->
            <div class="search-header">
              <div class="search-nav">
                <ul class="nav nav-pills" role="tablist">
                  <li class="nav-item" role="presentation">
                    <button class="nav-link active" id="pills-tab-1" data-bs-toggle="pill" data-bs-target="#pills-1"
                      type="button" role="tab" aria-controls="pills-1" aria-selected="true">
                      <i class="far fa-plane-departure"></i>{{'Flights' | lang}}
                    </button>
                  </li>
                </ul>
              </div>
            </div>

            <!-- search header end -->
            <router-outlet></router-outlet>

          </div>
        </div>
      </div>
      <!-- search area end -->
    </div>

  </div>
  <ng-container *ngIf="channel == 'B2C'">
    <!-- partner area -->
    <div class="partner-area2 pt-40 pb-0">
      <div class="container">
        <div class="partner-slider owl-carousel owl-theme">
          <img [src]="imgUrl + 'img/partner/01.png'" alt="thumb">
          <img [src]="imgUrl + 'img/partner/02.png'" alt="thumb">
          <img [src]="imgUrl + 'img/partner/03.png'" alt="thumb">
          <img [src]="imgUrl + 'img/partner/04.png'" alt="thumb">
          <img [src]="imgUrl + 'img/partner/01.png'" alt="thumb">
          <img [src]="imgUrl + 'img/partner/02.png'" alt="thumb">
          <img [src]="imgUrl + 'img/partner/03.png'" alt="thumb">
        </div>
      </div>
    </div>
    <!-- partner area end -->
    <!-- feature area -->
    <div class="feature-area2 pt-50" style="padding-top: 115px;">
      <div class="container">
        <div class="feature-wrapper">
          <div class="row g-4  justify-content-center">
            <div class="col-lg-6 col-xl-4">
              <div class="feature-item">
                <div class="feature-icon">
                  <img [src]="imgUrl + 'img/icon/world.svg'" alt="">
                </div>
                <div class="feature-content">
                  <h4 class="feature-title">{{'Worldwide Coverage' | lang}}</h4>
                  <p>
                    {{
                    'Book flights to 200+ destinations with trusted global airlines — wherever you’re headed, we’ve
                    got
                    you
                    covered.' | lang
                    }}
                  </p>
                </div>
              </div>
            </div>
            <div class="col-lg-6 col-xl-4">
              <div class="feature-item">
                <div class="feature-icon">
                  <img [src]="imgUrl + 'img/icon/quality.svg'" alt="">
                </div>
                <div class="feature-content">
                  <h4 class="feature-title">{{'Best Quality Services' | lang}}</h4>
                  <p>
                    {{
                    'Experience smooth booking, instant confirmations, and flexible options tailored to your trip.' |
                    lang
                    }}
                  </p>
                </div>
              </div>
            </div>
            <div class="col-lg-6 col-xl-4">
              <div class="feature-item">
                <div class="feature-icon">
                  <img [src]="imgUrl + 'img/icon/support.svg'" alt="">
                </div>
                <div class="feature-content">
                  <h4 class="feature-title">{{'24/7 Customer Service' | lang}}</h4>
                  <p>
                    {{'Get real-time help anytime through chat, WhatsApp, or call. We’re always here for you.' | lang}}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- feature area end -->
    <!-- about-area -->
    <div class="about-area pt-60 pb-60">
      <div class="container">
        <div class="row align-items-center">
          <div class="col-lg-6">
            <div class="about-left wow fadeInLeft" data-wow-delay=".25s">
              <div class="about-img">
                <div class="row">
                  <div class="col-6">
                    <img class="img-1" [src]="imgUrl + 'img/about/01.png'" alt="">
                  </div>
                  <div class="col-6">
                    <img class="img-2" [src]="imgUrl + 'img/about/02.png'" alt="">
                  </div>
                </div>
              </div>
              <div class="about-experience">
                <h5>{{'30' | lang}}<span>+</span></h5>
                <p>{{'Years Of Experience' | lang}}</p>
              </div>
            </div>
          </div>
          <div class="col-lg-6">
            <div class="about-right wow fadeInUp" data-wow-delay=".25s">
              <div class="site-heading mb-3">
                <span class="site-title-tagline"><i class="far fa-plane"></i> {{"About Us" | lang}}</span>
                <h2 class="site-title">
                  {{"Your" | lang}} <span>{{"Trusted Partner" | lang}}</span> {{"for" | lang}} <span>
                    {{
                    "Smarter Travel"
                    |
                    lang
                    }}
                  </span>
                </h2>
              </div>
              <p class="about-text">
                {{
                "At Taveelo, we simplify travel planning. From flights and stays to complete holiday packages,our
                platform connects you with the best deals across trusted partners.With over 30 years of industry
                expertise,we make booking quick, clear, and worry-free." | lang
                }}
              </p>
              <div class="about-content">
                <div class="row g-3">
                  <div class="col-xl-6 col-lg-12">
                    <div class="about-item">
                      <div class="icon">
                        <img [src]="imgUrl + 'img/icon/deal.svg'" alt="">
                      </div>
                      <div class="content">
                        <h6>{{'Get Your Best Deals' | lang}}</h6>
                        <p>{{'Unlock exclusive fares and members-only discounts on top airlines.' | lang}}</p>
                      </div>
                    </div>
                  </div>
                  <div class="col-xl-6 col-lg-12">
                    <div class="about-item">
                      <div class="icon">
                        <img [src]="imgUrl + 'img/icon/booking.svg'" alt="">
                      </div>
                      <div class="content">
                        <h6>{{'Easy To Booking' | lang}}</h6>
                        <p>{{'Search, compare, and confirm — all in a few taps.' | lang}}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- <a href="about.html" class="theme-btn">
                Discover More <i class="fas fa-arrow-circle-right"></i>
              </a> -->
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- about-area end -->
    <!-- counter area -->
    <div class="counter-area">
      <div class="col-lg-11 col-xl-9">
        <div class="counter-wrap">
          <div class="row">
            <div class="col-lg-3 col-sm-6">
              <div class="counter-box">
                <div class="icon">
                  <img [src]="imgUrl + 'img/icon/booking-confirm.svg'" alt="">
                </div>
                <div class="counter-content">
                  <div class="counter-number">
                    <span class="counter" data-count="+" data-to="120" data-speed="3000">120</span>
                    <span class="counter-sign">k</span>
                  </div>
                  <h6 class="title">{{'Booking Done' | lang}}</h6>
                </div>
              </div>
            </div>
            <div class="col-lg-3 col-sm-6">
              <div class="counter-box">
                <div class="icon">
                  <img [src]="imgUrl + 'img/icon/destination.svg'" alt="">
                </div>
                <div class="counter-content">
                  <div class="counter-number">
                    <span class="counter" data-count="+" data-to="200" data-speed="3000">200</span>
                    <span class="counter-sign">+</span>
                  </div>
                  <h6 class="title">{{'Our Destination' | lang}}</h6>
                </div>
              </div>
            </div>
            <div class="col-lg-3 col-sm-6">
              <div class="counter-box">
                <div class="icon">
                  <img [src]="imgUrl + 'img/icon/rating.svg'" alt="">
                </div>
                <div class="counter-content">
                  <div class="counter-number">
                    <span class="counter" data-count="+" data-to="40" data-speed="3000">40</span>
                    <span class="counter-sign">k</span>
                  </div>
                  <h6 class="title">{{'Happy Clients' | lang}}</h6>
                </div>
              </div>
            </div>
            <div class="col-lg-3 col-sm-6">
              <div class="counter-box">
                <div class="icon">
                  <img [src]="imgUrl + 'img/icon/partner.svg'" alt="">
                </div>
                <div class="counter-content">
                  <div class="counter-number">
                    <span class="counter" data-count="+" data-to="180" data-speed="3000">180</span>
                    <span class="counter-sign">+</span>
                  </div>
                  <h6 class="title">{{'Our Partners' | lang}}</h6>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- counter area end -->
    <!-- flight area -->
    <div class="flight-area py-120">
      <div class="container">
        <div class="row">
          <div class="col-lg-6 mx-auto wow fadeInDown" data-wow-duration="1s" data-wow-delay=".25s">
            <div class="site-heading text-center">
              <span class="site-title-tagline"><i class="far fa-plane"></i> {{'Trending Flight Deals' | lang}}</span>
              <h2 class="site-title">{{'Grab the latest offers' | lang}}</h2>
            </div>
          </div>
        </div>
        <div class="row align-items-center justify-content-center">
          <div class="col-md-6 col-lg-4 col-xl-3" *ngFor="let f of featuredFlights; let i = index">
            <div class="flight-item" (click)="goToSearch(f,i)" style="cursor:pointer;">
              <div class="flight-img">
                <img [src]="f.img" alt="">
              </div>
              <div class="flight-content">
                <div class="flight-title-info">
                  <div class="flight-title">
                    <h4>
                      <a href="#">
                        <i class="fas fa-plane-departure"></i>
                        {{f.titleFrom}} <i class="far fa-exchange"></i> {{f.titleTo}}
                      </a>
                    </h4>
                    <p class="flight-date">
                      <i class="far fa-calendar-days"></i>
                      {{f.dep | date:'dd MMM YYYY'}} - {{f.ret | date:'dd MMM YYYY'}}
                    </p>
                  </div>
                </div>

                <div class="flight-bottom">
                  <div class="flight-price"></div>

                  <div class="flight-text-btn">
                    <a style="cursor:pointer;" href="javascript:void(0)" *ngIf="!loading[i]">
                      {{'See Details' | lang}} <i class="fas fa-arrow-right"></i>
                    </a>
                    <div *ngIf="loading[i]" class="spinner-border" role="status" style="width: 20px; height: 20px;">
                    </div>
                  </div>

                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- flight area end -->
    <!-- video-area -->
    <div class="video-area">
      <div class="container-fluid pe-0 p-lg-0">
        <div class="col-lg-11 ms-lg-auto">
          <div class="row g-4 align-items-center">
            <div class="col-md-8 col-lg-4 wow fadeInLeft" data-wow-delay=".25s">
              <div class="site-heading mb-3">
                <span class="site-title-tagline">
                  <i class="far fa-plane"></i> {{
                  'See Why Travelers Love Taveelo' |
                  lang
                  }}
                </span>
                <h2 class="site-title">
                  {{"Let's Check Our" | lang}} <span>{{'Latest Update' | lang}}</span> {{'And Video' | lang}}
                </h2>
              </div>
              <p class="about-text">
                {{
                'Watch how we help thousands plan smarter trips, from last-minute getaways to once-in-a-lifetime
                adventures.' | lang
                }}
              </p>
              <a href="https://www.youtube.com/watch?v=3VLamwO0Zr0" target="_blank" class="theme-btn mt-30">
                {{'Watch Video' | lang}}<i class="fas fa-arrow-circle-right"></i>
              </a>
            </div>
            <div class="col-lg-8 wow fadeInRight" data-wow-delay=".25s">
              <div class="video-content" [style.background-image]="'url(' + imgUrl + 'img/video/01.png)'">
                <div class="row align-items-center">
                  <div class="col-lg-12">
                    <div class="video-wrapper">
                      <a class="play-btn popup-youtube" href="https://www.youtube.com/watch?v=3VLamwO0Zr0"
                        target="_blank">
                        <i class="fas fa-play"></i>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- video-area end -->
    <!-- tour area -->
    <div class="tour-area py-120">

    </div>
    <!-- tour area end -->
    <!-- cta-area -->
    <div class="cta-area">
      <div class="container">
        <div class="cta-wrapper">
          <div class="col-md-10 col-lg-8 col-xl-6 mx-auto">
            <div class="cta-content">
              <div class="cta-text">
                <h1>{{'Your First Booking' | lang}} <span>{{'Get 70%' | lang}}</span> {{'Off!' | lang}}</h1>
                <p>
                  {{
                  'Sign up today and enjoy an exclusive discount on your first flight or hotel booking. Limited-time
                  offer for new users only.' | lang
                  }}
                </p>
              </div>
              <a href="/" class="theme-btn mt-20">{{'Book Now' | lang}} <i class="fas fa-arrow-circle-right"></i></a>
            </div>
          </div>
          <div class="cta-img">
            <img [src]="imgUrl + 'img/cta/01.png'" alt="">
          </div>
        </div>
      </div>
    </div>
    <!-- cta-area end -->
    <!-- choose area -->
    <div class="choose-area py-120">
      <div class="container">
        <div class="row">
          <div class="col-lg-6 mx-auto wow fadeInDown" data-wow-duration="1s" data-wow-delay=".25s">
            <div class="site-heading text-center">
              <span class="site-title-tagline">
                <i class="far fa-plane"></i> {{
                'Why Travelers Choose Taveelo' |
                lang
                }}
              </span>
              <h2 class="site-title">{{'Discover Beautiful Places With Us' | lang}}</h2>
            </div>
          </div>
        </div>
        <div class="row align-items-center">
          <div class="col-lg-6 wow fadeInLeft" data-wow-duration="1s" data-wow-delay=".25s">
            <div class="choose-item">
              <span class="count">01</span>
              <div class="icon">
                <img [src]="imgUrl + 'img/icon/safety.svg'" alt="">
              </div>
              <div class="content">
                <h4>{{'Safety And Trust' | lang}}</h4>
                <p>
                  {{'Partnered with verified airlines and hotels to keep your journeys secure.' | lang}}
                </p>
              </div>
            </div>
            <div class="choose-item">
              <span class="count">02</span>
              <div class="icon">
                <img [src]="imgUrl + 'img/icon/price.svg'" alt="">
              </div>
              <div class="content">
                <h4>{{'100% Price Transparency' | lang}}</h4>
                <p>
                  {{'What you see is what you pay — no hidden costs or last-minute surprises.' | lang}}
                </p>
              </div>
            </div>
            <div class="choose-item">
              <span class="count">03</span>
              <div class="icon">
                <img [src]="imgUrl + 'img/icon/booking-confirm.svg'" alt="">
              </div>
              <div class="content">
                <h4>{{'Travel With More Confidence' | lang}}</h4>
                <p>
                  {{
                  'Flexible options, instant support, and simple refund processes make traveling stress-free.' |
                  lang
                  }}
                </p>
              </div>
            </div>
          </div>
          <div class="col-lg-6 wow fadeInRight" data-wow-duration="1s" data-wow-delay=".25s">
            <div class="choose-img">
              <img class="shape" [src]="imgUrl + 'img/shape/04.png'" alt="">
              <img class="img-1" [src]="imgUrl + 'img/choose/01.png'" alt="">
              <img class="img-2" [src]="imgUrl + 'img/choose/02.png'" alt="">
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- choose area end -->
  </ng-container>
</main>

<style>
  .spinner-border {
    color: #24bdc7;
  }

  .hero-single {
    padding-top: 160px !important;
    padding-bottom: 140px !important;
  }

  .isResSearch {
    margin-top: -303px;
  }

  .isResHero {
    margin-top: -150px;
  }

  /* ========== NON-B2C FULL HERO (Desktop) ========== */
  @media (min-width: 992px) {
    .full-hero-layout {
      position: relative;
      width: 100%;
      min-height: calc(100vh - 130px);
      overflow: visible;
    }

    .full-hero-layout .hero-single {
      width: 100%;
      min-height: calc(100vh - 130px);
      background-size: cover;
      background-position: center;
      background-repeat: no-repeat;
      display: flex;
      align-items: center;
      padding-top: 140px !important;
      padding-bottom: 140px !important;
    }

    .full-hero-layout+.search-area {
      position: absolute;
      bottom: 30px;
      left: 0;
      width: 100%;
      z-index: 10;
      margin: 0 !important;
    }
  }

  /* ========== MOBILE RESPONSIVE FIX (Mobile & Tablet) ========== */
  @media (max-width: 991px) {
    body.full-hero-page {
      overflow-y: auto !important;
    }

    .hero-single {
      padding-top: 100px !important;
      padding-bottom: 25px !important;
    }

    .full-hero-layout {
      position: relative !important;
      width: 100% !important;
      height: auto !important;
      min-height: auto !important;
      z-index: 1 !important;
      overflow: visible !important;
    }

    .full-hero-layout .hero-single {
      width: 100% !important;
      height: auto !important;
      min-height: auto !important;
      background-size: cover !important;
      background-position: center !important;
      background-repeat: no-repeat !important;
      padding-top: 96px !important;
      padding-bottom: 10px !important;
    }

    .full-hero-layout .hero-content {
      display: none !important;
    }

    .full-hero-layout+.search-area {
      position: relative !important;
      bottom: auto !important;
      left: auto !important;
      width: 100% !important;
      z-index: 10 !important;
      margin: 0 auto !important;
      padding-top: 10px !important;
      padding-bottom: 25px !important;
      min-height: auto !important;
    }

    .isResHero {
      margin-top: 0 !important;
    }

    .isResSearch {
      margin-top: 0 !important;
    }

    .search-wrapper {
      margin-top: 0 !important;
    }

    .search-header {
      margin-left: 12px !important;
      margin-bottom: 0 !important;
    }

    .search-nav {
      margin-bottom: -18px !important;
      position: relative !important;
      z-index: 5 !important;
    }

    .search-nav .nav-link {
      padding: 7px 16px !important;
      font-size: 13px !important;
      font-weight: 600 !important;
    }

    .search-wrapper .tab-content {
      padding: 26px 14px 18px 14px !important;
      border-radius: 16px !important;
      box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1) !important;
    }
  }
</style>